/* eslint-disable no-unused-vars */
export enum TabTypes {
  INLINE = 'inline',
  PRODUCT = 'product',
  BUTTON = 'button',
}
